/*
PURPOSE: Reusable MessageCirclePlus icon component with thin stroke weight

USE CASES:
- Used in ContributeButton for comment contribution actions
- Maintains consistent icon appearance across the comment system
- Provides customizable size and color options

DOMAIN BOUNDARIES:
- Only responsible for rendering the SVG icon
- Should NOT contain any business logic or event handlers
- Should NOT have knowledge of comment system functionality

ASSUMPTIONS:
- Default styling matches the comment system's visual design
- Stroke width of 1 provides the desired thin appearance
*/

import React from 'react';

interface MessageCirclePlusIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const MessageCirclePlusIcon: React.FC<MessageCirclePlusIconProps> = ({ 
  className = "", 
  size = 20,
  color = "#9CA3AF"
}) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke={color} 
    strokeWidth="1" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={`lucide lucide-message-circle-plus-icon ${className}`}
  >
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>
    <path d="M8 12h8"/>
    <path d="M12 8v8"/>
  </svg>
);

export default MessageCirclePlusIcon;